module.exports = __webpack_public_path__ + "img/天气.744d7525.png";